import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { BOOKING_STEP3 } from '../core/redux/features/booking/constants';
import { selectActiveProduct } from '../core/redux/features/products/reducers/products';
import { AppState } from '../core/redux/reducers';

export const sendGAEvent = (_args: any) => {
  // // @ts-ignore
  // window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  // window.dataLayer.push(args);
  // if (process.env.NODE_ENV !== 'production') {
  //   // @ts-ignore
  //   console.log('GA:', args);
  // }
};

export const GATagEvent = (..._args: any) => {
  if (typeof window.gtag === 'undefined') {
    return null;
  }

  // window.gtag(...args);
  //
  // if (process.env.NODE_ENV !== 'production') {
  //   console.log('GATAG:', args);
  // }
};

export const GAPageView = (url: string = null) => {
  try {
    if (url === null) {
      url = window.location.pathname;
    }
  } catch (_e) {}

  try {
    if (url === null) {
      url = window.location.pathname;
    }
    if (window.ga !== undefined) {
      if (url !== null) {
        window.ga('send', 'pageview', url);
      } else {
        window.ga('send', 'pageview');
      }
    }
  } catch (_e) {
    console.warn('GA: failed to track page view');
  }
};

export const useGAViewContent = () => {
  const activeProduct = useSelector(selectActiveProduct);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!activeProduct) {
      return;
    }

    const productType = activeProduct.product_type;
    const productId = activeProduct.id;

    GATagEvent('event', 'view_item', {
      items: [
        {
          id: productId,
          name: activeProduct.name,
          category: productType,
        },
      ],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeProduct && activeProduct.id]);
};

export const useGAAddToCart = () => {
  const product = useSelector(selectActiveProduct);
  const { activeStep, order } = useSelector((state: AppState) => ({
    activeStep: state.booking.activeStepIndex,
    order: state.booking.order,
  }));

  useEffect(() => {
    if (activeStep !== BOOKING_STEP3) {
      return;
    }

    const price = order.total;
    const orderId = order.hold_id;
    const productType = product.product_type;
    const productId = product.id;

    if (!price || !orderId || !productType || !productId) {
      return;
    }

    GATagEvent('event', 'add_to_cart', {
      items: [
        {
          id: productId,
          name: product.name,
          category: productType,
          quantity: 1,
          price: price,
        },
      ],
    });
  }, [activeStep, order, product.product_type, product.id, product.name]);
};

export const useGAPurchase = () => {
  const lastOrderId = useRef<any>();
  useEffect(() => {
    const currency = window.__pixel_data?.currency;
    const price = window.__pixel_data?.total;
    const orderId = window.__pixel_data?.order_id;
    const productType = window.__pixel_data?.product_type;
    const productId = window.__pixel_data?.restaurant_id;
    const productName = window.__pixel_data?.restaurant_name;

    if (
      !currency ||
      !price ||
      !orderId ||
      !productType ||
      lastOrderId.current === orderId
    ) {
      return;
    }

    lastOrderId.current = orderId;
    GATagEvent('event', 'purchase', {
      transaction_id: orderId,
      value: price,
      currency: currency,
      items: [
        {
          id: productId,
          name: productName,
          category: productType,
          quantity: 1,
          price: price,
        },
      ],
    });
  }, []);
};
